import React, { Component } from 'react'
import ItemTypes from './ItemTypes'
import { Container } from 'reactstrap';
import SubHeader from './periodical_subheader';
import LoadConfigForm from './load_config_form';
import PeriodicalIteams from './periodical_iteam';
import FrequencyList from './frequency_list';
import simpleReactValidator from 'simple-react-validator';
import { connect } from 'react-redux';
import AlertSuccess from 'shared/components/Alerts/alert_success';
import ContractPeridicalModal from 'shared/components/Models/contract_periodical_model';
import {fetchGroupList,fetchContractList,fetchChargesList,fetchPreferanceList,fetchFacilityList,fetchReportingList} from 'shared/actions/actions';
import {fetchFrequencyList} from 'shared/actions/frequency_action';
import {checkExistContractFacility,createContractPeridicals,createContractFacilityPeriodicals,contractFacilityPeriodicalsData,updateFacilityPeriodicalsData,isWorkingOnPeriodical,removeFacilityPeriodical,resetFacilityPeriodical} from 'shared/actions/allocation_action';
import DeleteConfirmationModel from 'shared/components/Models/delete_confirmation_model';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';




 class PeriodicalConfig extends Component {
	constructor(props) {
		super(props)
		this.validator = new simpleReactValidator();
		this.state = {
			periodical :[],
			droppedBoxNames: [],
			dustbinsBoxList:[],
			selected_group:0,
			selected_contract:0,
			selected_facility:0,
			show_error:false,
			modal:false,
			periodical_data:[],
			charged_show:0,
			configured_data:false,
			show_error_no_element:false,
			show_div:false,
			exist_peridicals:[],
			exist_update:false,
			delete_model:false,
			del_frequency_id:0,
			show_dlt_error:false,
			show_nodelet:false,
			work_count:0,
			move_id:0,
			freq_id:0,
			occur_count:0,
			load_grop_id:0,
			load_facility_id:0,
			load_from:false,
			load_no_data:false,
			blocking: false,
			visible: true,
			reporting_field:[{field_id:0,data_type_id:1,label:"",is_mandatory:1}],
			reporting_array:[]
			
		}

		this.onGroupChange = this.onGroupChange.bind(this);
		this.onFacilityChange=this.onFacilityChange.bind(this);
		this.onApplyClick=this.onApplyClick.bind(this);
		this.saveClick=this.saveClick.bind(this);
		this.oncheck=this.oncheck.bind(this);
		this.toggle=this.toggle.bind(this);
		this.onSubmitClick=this.onSubmitClick.bind(this);
		this.txtOnchange=this.txtOnchange.bind(this);
		this.onpClick=this.onpClick.bind(this);
		this.confim_delete=this.confim_delete.bind(this);
		this.delete_toggle=this.delete_toggle.bind(this);
		this.onLoadGroupChange=this.onLoadGroupChange.bind(this);
		this.onLoadClick=this.onLoadClick.bind(this);
		this.onLoadFacilityChange=this.onLoadFacilityChange.bind(this);
		this.resetClick=this.resetClick.bind(this);
		this.onDismiss = this.onDismiss.bind(this);
		this.delete_report_click=this.delete_report_click.bind(this);
		this.onMandatoryCheck=this.onMandatoryCheck.bind(this);
		this.onrChange=this.onrChange.bind(this);
		this.saverClick=this.saverClick.bind(this);
	}


	componentDidMount() {
		const { dispatch } = this.props
		dispatch(fetchGroupList())
		dispatch(fetchFrequencyList())
		dispatch(fetchChargesList())
		dispatch(fetchPreferanceList())
		dispatch(fetchReportingList())
		this.setState({
            blocking:!this.state.blocking
        })
	}

	componentDidUpdate(prevProps, prevState) {
		
		var that=this;	

		  if(prevProps.group_data!=this.props.group_data){
			this.setState({ blocking: false });
		  }
		  
		  if(prevProps.contract_data!=this.props.contract_data){
			this.setState({ blocking: false });
		  }

		  if(prevProps.facility_data!=this.props.facility_data){
			this.setState({ blocking: false });
		  }

		  if(prevProps.allocation_response!=this.props.allocation_response){
			this.setState({ blocking: false,visible:true });
		  }

		  // Check if facility is already configured
		  if(prevProps.is_exist_contract_facility!==this.props.is_exist_contract_facility)
		  {
			  var count=this.props.is_exist_contract_facility.result[0].count;
			  var facility_id=this.state.selected_facility;
			  
			  if(count>0 && facility_id>0)
			  {
				// Facility has existing configuration - load it
				this.props.dispatch(contractFacilityPeriodicalsData(facility_id));
				this.props.dispatch(createContractPeridicals(this.state.selected_contract));
				
				this.setState({
					show_error:false,
					configured_data:true,
					show_div:true,
					blocking: false
				})
			  }
			  else
			  {
				// New configuration
				this.props.dispatch(createContractPeridicals(this.state.selected_contract));
				this.setState({
					show_error:false,
					show_div:true,
					blocking: false
				})
			  }
		  }

		if(prevProps.contract_facilitys_data!==this.props.contract_facilitys_data && this.state.load_from==true){
		   console.log("load here");
		   if(this.props.contract_facilitys_data.length>0)
		   {
		   var perodical_data=this.state.periodical;
		   var cdata=this.props.contract_facilitys_data;
		   var pdata1=this.props.contract_peridicals_data;
		   var exist_periodical=this.props.contract_peridicals_data;
		   var frequency_periodicaldata=[];

		   perodical_data.forEach(element => {
			for(var i=0; i<cdata.length; i++) 
			{
				if(element.periodical_id==cdata[i].periodical_id)
				{
					//console.log("match found");

                    var list_data = cdata.filter(function(k) { 
						return k.periodical_id == cdata[i].periodical_id 
					});
					//console.log(element.id)
					var new_element={id:element.id, name: list_data[0].name,description:list_data[0].description,periodical_id:list_data[0].periodical_id,occurrence_id:list_data[0].occurrence_id,frequency_count:list_data[0].frequency_count,allocation_preference_id:list_data[0].allocation_preference_id,is_separately_charge:list_data[0].is_separately_charge,charge_type_id:list_data[0].charge_type_id,charge_amount:list_data[0].charge_amount,status:list_data[0].status,notes:'',icon:list_data[0].icon,reporting_fields:list_data[0].reporting_fields};
                    console.log(new_element);
                    frequency_periodicaldata.push(new_element);

					var list_data1 = pdata1.filter(function(y) { 
						return y.periodical_id !=cdata[i].periodical_id 
					});
					pdata1=list_data1;
					return false;
				}
			}
		});

		this.setState({
			dustbinsBoxList:frequency_periodicaldata,
			periodical:pdata1,
			exist_peridicals:exist_periodical,
			blocking: false
		  });

		  console.log(pdata1);
		}
		else
		{
		console.log("no data found")
			var exist_peridicals=this.state.exist_peridicals;
			this.setState({
				load_no_data:true,
				periodical:exist_peridicals,
				dustbinsBoxList:[],
				blocking: false,
				visible:true
			})
		}
		   
		}

		if(this.state.configured_data==true)
		{
		  
		  if(prevProps.contract_peridicals_data!==this.props.contract_peridicals_data && this.props.contract_facilitys_data.length>0)
		  {
			  
			  console.log(this.props.contract_peridicals_data);
				  var frequency_data_list=[];
				  var peridical_data_list=[];
				  var periodicalLists=[];
				  var pdata=this.props.contract_peridicals_data;
				  var pdata1=this.props.contract_peridicals_data;
				  var cdata=this.props.contract_facilitys_data;

					  pdata.forEach(element => {
						  for(var i=0; i<cdata.length; i++) 
						  {
							  if(element.id==cdata[i].contract_periodical_id)
							  {
								  var list_data1 = pdata1.filter(function(y) { return y.id !=cdata[i].contract_periodical_id });
								  pdata1=list_data1;
								  return false;
							  }
						  }
					  });
					  
					  console.log(pdata1);
					  this.setState({
					  dustbinsBoxList:this.props.contract_facilitys_data,
					  periodical:pdata1,
					  exist_peridicals:pdata1,
					  blocking: false
					});
				  
			  }
			  
		  }
		  else
		  {
			 
			  if(prevProps.contract_peridicals_data!==this.props.contract_peridicals_data)
			  {
				   console.log("out loop");
				this.setState({
					periodical:this.props.contract_peridicals_data,
					exist_peridicals:this.props.contract_peridicals_data,
					blocking: false
				  });
			  }
		  }





		if(prevProps.is_working_count!==this.props.is_working_count){
			 var id=this.state.del_frequency_id;
			var count=this.props.is_working_count.result[0].count;
			console.log(count);
			that.setState({
				work_count:count
			})
			if(count>0)
			{
			  //console.log("work in progress");
			  this.setState({
				show_nodelet:true,
				blocking: false,
				visible:true
			  })
			  
			}
			else
			{
				//console.log("delete here");
				if(id>0)
				{
					var single_periodical = this.state.dustbinsBoxList.filter(function(y) { return y.id == id });
					var ramin_list = this.state.dustbinsBoxList.filter(function(y) { return y.id != id });
					var deleted = this.state.periodical.slice();

					var new_element;
					if(single_periodical != null && single_periodical != "")
					{
						new_element = {
							id: single_periodical[0].id,
							name: single_periodical[0].name,
							description: single_periodical[0].description,
							periodical_id: single_periodical[0].periodical_id,
							occurrence_id: single_periodical[0].occurrence_id,
							frequency_count: single_periodical[0].frequency_count,
							allocation_preference_id: single_periodical[0].allocation_preference_id,
							is_separately_charge: single_periodical[0].is_separately_charge,
							charge_type_id: single_periodical[0].charge_type_id,
							charge_amount: single_periodical[0].charge_amount,
							status: single_periodical[0].status,
							icon: single_periodical[0].icon,
							reporting_fields: single_periodical[0].reporting_fields
						};
					}

					that.props.dispatch(removeFacilityPeriodical(id))
					.then((apiResponse) => {

						if(apiResponse && apiResponse.success === false) {
							that.setState({
								blocking: false,
								dustbinsBoxList: that.state.dustbinsBoxList,
								periodical: that.state.periodical,
								show_nodelet: true,
								show_dlt_error: false,
								visible: true
							});
						} else {
							deleted.push(new_element);
							that.setState({
								dustbinsBoxList: ramin_list,
								periodical: deleted,
								blocking: false,
								show_dlt_error: true,
								show_nodelet: false,
								visible: true
							});
						}
					});
				}

				
				 if(count>0){
						console.log("you can not delete");
				   }
				   else
				   {
					   console.log("you can delete")
					   var pid=this.state.move_id;
					   if(pid>0)
					   {
						var parray=[];
						this.props.dispatch(resetFacilityPeriodical(pid));
						var frequency_id=this.state.freq_id;
						var occurence=this.state.occur_count;
						var list_data = that.state.dustbinsBoxList.filter(function(y) { return y.id != pid });
						var list_element = that.state.dustbinsBoxList.filter(function(y) { return y.id == pid });
						var new_element_one={id:list_element[0].id, name: list_element[0].name,description:list_element[0].description,occurrence_id:frequency_id,periodical_id:list_element[0].periodical_id,frequency_count:occurence,allocation_preference_id:list_element[0].allocation_preference_id,is_separately_charge:list_element[0].is_separately_charge,charge_type_id:list_element[0].charge_type_id,charge_amount:list_element[0].charge_amount,status:list_element[0].status,tbl:list_element[0].tbl,notes:list_element[0].notes,icon:list_element[0].icon,reporting_fields:list_element[0].reporting_fields};
						list_data.push(new_element_one);
						parray.push(new_element_one);

						this.setState({
							   	dustbinsBoxList : list_data,
							   	charged_show:new_element_one.is_separately_charge,
							   	periodical_data:parray,
							   	modal:true,
								work_count:0,
								freq_id:0,
								occur_count:0,
								blocking: false
							});
					   }
				   }
			}
		}
	}

	delete_report_click=(e)=>{

		console.log(e)

		var list_element = this.state.reporting_array.filter(function(y) { 
			return y.field_id!=e
		 });

		 this.setState({
			reporting_array:list_element
		 })
		
	   console.log(list_element);
	  }

	  onMandatoryCheck=(e)=>{
		var that=this;
		var id=e.target.id;
		id=id.split("-");
		var periodical = that.state.reporting_field.filter(function(item) { 
		  if(item.field_id == id[1])
		  {
			var val=item[id[0]];
			//console.log(val)
			if(val==1)
			{
			  item[id[0]]=0;
			}
			else
			{
			  item[id[0]]=1;
			}
			
		  }
		   return item
		});
		that.setState({reporting_field:periodical});
		var that=this;
	  }
	  
	  onrChange=(e)=>{
		var that=this;
		var id=e.target.id;
		var value=e.target.value;
		id=id.split("-");
		var periodical = that.state.reporting_field.filter(function(item) { 
		  if(item.field_id == id[1])
		  {
			  item[id[0]]=value;
		  }
		   return item
		});
		that.setState({reporting_field:periodical});
	  }
	  
	  onrdropChange=(e)=>{
		var that=this;
		var id=e.target.id;
		var text=e.target[e.target.selectedIndex].text;
		var value=e.target.value;
		id=id.split("-");
		var periodical = that.state.reporting_field.filter(function(item) { 
		  if(item.field_id == id[1])
		  {
			  item[id[0]]=value;
		  }
		   return item
		});
		that.setState({reporting_field:periodical});
	  
	  }

	  
	  saverClick=(e)=>{
	var that=this;
	var report=this.state.reporting_field;
  
	var field_id=report[0].field_id;
	var label=report[0].label;
	var data_type_id=report[0].data_type_id;
	var is_mandatory=report[0].is_mandatory;
  
	if(label!="" && data_type_id>0)
	{
	  var rarray=this.state.reporting_array;
	  if(rarray.length>0)
	  {
		field_id=rarray.slice(-1)[0].field_id;
	  }
	  
	  rarray.push({field_id:field_id+1,label:label,data_type_id:data_type_id,is_mandatory:is_mandatory});
	  var fresh_field=[{field_id:0,data_type_id:'1',label:'',is_mandatory:1}]
	  this.setState({
		reporting_array:rarray,
		reporting_field:fresh_field
	  })
	  console.log(this.state.reporting_field)
	}
  
  }

	  

	onDismiss() {
        this.setState({ visible: false });
	  }

	
	onpClick=(e)=>{
		this.validator.hideMessages();
		console.log("edit click");
		this.setState({
			show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
			del_frequency_id:0,
            work_count:0,
			freq_id:0,
			occur_count:0
		})
		if(e>0){
			var list_element = this.state.dustbinsBoxList.filter(function(y) { return y.id == e });
			console.log(list_element);

			 var amount=list_element[0].charge_amount;
				if(amount!="" && amount!=null){
					amount=amount.toString();
				}
			var new_element=[{id:list_element[0].id, name: list_element[0].name,description:list_element[0].description,occurrence_id:list_element[0].occurrence_id,periodical_id:list_element[0].periodical_id,frequency_count:list_element[0].frequency_count,allocation_preference_id:list_element[0].allocation_preference_id,is_separately_charge:list_element[0].is_separately_charge,charge_type_id:list_element[0].charge_type_id,charge_amount:amount,status:list_element[0].status,tbl:list_element[0].tbl,notes:list_element[0].notes,icon:list_element[0].icon,reporting_fields:list_element[0].reporting_fields}];

			this.setState({
				drag_id:e,
				charged_show:list_element[0].is_separately_charge,
				periodical_data:new_element,
				reporting_array:list_element[0].reporting_fields,
				modal:true,
				blocking: false
			})
		}
	}

	onLoadGroupChange=(e)=>{
		var id=e.target.value;
		
		if(id>0){
			this.props.dispatch(fetchFacilityList(id))
			
			this.setState({
				load_grop_id:id,
				load_from:false,
				blocking: true
			})
		}
		else{
			this.setState({
				load_grop_id:0,
				load_from:false,
				blocking: false
			})
		}
	}

	onLoadFacilityChange=(e)=>{
		
		var id=e.target.value;
		if(id>0){
			this.setState({
				load_facility_id:id,
				load_from:false
			})
		}
		else{
			this.setState({
				load_facility_id:0,
				load_from:false
			})
		}
	}

	onLoadClick=(e)=>{
		var group_id=this.state.load_grop_id;
		var facility_id=this.state.load_facility_id;
		console.log(facility_id)
		if(group_id>0 && facility_id>0){
			this.props.dispatch(contractFacilityPeriodicalsData(facility_id));
			this.setState({
				load_from:true,
				blocking: true,
				visible:true,
				show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,

			})
		}
	}

	confim_delete(){

		this.setState({
			show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
            work_count:0,
			freq_id:0,
			occur_count:0
		})
		var e=this.state.del_frequency_id
		if(e>0)
		{
			var single_periodical = this.state.dustbinsBoxList.filter(function(y) { return y.id == e });

			if(this.state.configured_data==false || single_periodical[0].tbl>0){
			
			var ramin_list=this.state.dustbinsBoxList.filter(function(y) { return y.id != e });
			var deleted=this.state.periodical;
			
			//console.log(single_periodical);
			var new_element;

			if(single_periodical!=null && single_periodical!="")
			{
				new_element={id:single_periodical[0].id, name: single_periodical[0].name,description:single_periodical[0].description,periodical_id:single_periodical[0].periodical_id,occurrence_id:single_periodical[0].occurrence_id,frequency_count:single_periodical[0].frequency_count,allocation_preference_id:single_periodical[0].allocation_preference_id,is_separately_charge:single_periodical[0].is_separately_charge,charge_type_id:single_periodical[0].charge_type_id,charge_amount:single_periodical[0].charge_amount,status:single_periodical[0].status,icon:single_periodical[0].icon};
			}
			deleted.push(new_element);

			this.setState({
				dustbinsBoxList:ramin_list,
				periodical:deleted,
				show_dlt_error:true,
				delete_model:false,
				visible:true
				//blocking: true
			})

			}
			else{
				console.log("config");
				this.props.dispatch(isWorkingOnPeriodical(this.state.del_frequency_id));
				this.setState({
					delete_model: false, blocking: true
				  });
			}
		}
	}

	delete_toggle=(e)=>{
		this.setState({
		  del_frequency_id:e,
		  delete_model: !this.state.delete_model,
		  show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
            work_count:0,
			freq_id:0,
			occur_count:0
		});
	  }

	oncheck=(e)=>{

		var that=this;
		var id=e.target.id;
        id=id.split("-");
		var value=0;
		var is_charged=this.state.charged_show;
		//console.log(is_charged);
		if(is_charged==1){
			value=0;
		  that.setState({
		   charged_show:0
		  })
		}
		else
		{
		 value=1;
		 that.setState({
		   charged_show:1
		  })
		}

		var periodical = that.state.periodical_data.filter(function(item) { 
			if(item.id == id[1])
			{
				item[id[0]]=value;
				if(item.is_separately_charge==0)
				{
					item.charge_amount=0;
					item.charge_type_id=0
				}
			}
			 return item
		  });
		  that.setState({periodical_data:periodical});
	 }

	 txtOnchange=(e)=>{
		var that=this;
		var id=e.target.id;
		id=id.split("-");
		var value=e.target.value;
		if(value=="undefined")
		{
		  value="";
		}
		var periodical = that.state.periodical_data.filter(function(item) { 
		  if(item.id == id[1])
		  {
			item[id[0]]=value;
		  }
		   return item
		});
		that.setState({periodical_data:periodical});
	  }

	 onSubmitClick(){
				var that=this;
				this.setState({
					show_error:false,
					show_error_no_element:false,
					show_dlt_error:false,
					show_nodelet:false,
					del_frequency_id:0,
					work_count:0,
					freq_id:0,
					occur_count:0,
					drag_id:0

				})
				var updated_periodical=this.state.periodical_data;
				var rarray=this.state.reporting_array;
				console.log(rarray)
				if(updated_periodical[0].is_separately_charge==1)
				{
					if(that.validator.fieldValid("charge_amount") && that.validator.fieldValid("charge_type_id"))
					{
						var periodical = that.state.dustbinsBoxList.filter(function(item) { 
							if(item.id == updated_periodical[0].id)
							{
								item.is_separately_charge=updated_periodical[0].is_separately_charge;
								item.charge_amount=updated_periodical[0].charge_amount;
								item.charge_type_id=updated_periodical[0].charge_type_id;
								item.reporting_fields=rarray;
								item.notes=updated_periodical[0].notes;
							}
								return item
							});
							that.setState({
								dustbinsBoxList:periodical,
							modal: !this.state.modal});
					}
					else
					{
						that.validator.showMessages();
                        that.forceUpdate();
					}
				}
				else
				{
					var periodical = that.state.dustbinsBoxList.filter(function(item) { 
						if(item.id == updated_periodical[0].id)
						{
							item.is_separately_charge=updated_periodical[0].is_separately_charge;
							item.charge_amount=updated_periodical[0].charge_amount;
							item.charge_type_id=updated_periodical[0].charge_type_id;
							item.reporting_fields=rarray;
							item.notes=updated_periodical[0].notes;
						}
							return item
						});
						that.setState({
							dustbinsBoxList:periodical,
						modal: !this.state.modal});
				}

				console.log(this.state.dustbinsBoxList)
				
	 }

	isDropped(boxName) 
	{
		return this.state.droppedBoxNames.indexOf(boxName) > -1
	}

	onGroupChange=(e)=>{
		this.validator.hideMessages();
		this.setState({
			show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
			del_frequency_id:0,
            work_count:0,
			freq_id:0,
			occur_count:0
		})
		var id=e.target.value;
		if(id>0)
		{
			// Fetch facilities directly based on group (like scheduling flow)
			this.props.dispatch(fetchFacilityList(id));
			// Also fetch contracts for the group
			this.props.dispatch(fetchContractList(id));
			this.setState({
				selected_group:id,
				selected_facility:0,
				selected_contract:0,
				show_div:false,
				dustbinsBoxList:[],
				periodical:[],
				exist_update:false,
				configured_data:false,
				blocking: true
			})
		}
		else
		{
			this.setState({
				selected_group:0,
				selected_facility:0,
				selected_contract:0,
				show_div:false,
				dustbinsBoxList:[],
				periodical:[],
				exist_update:false,
				configured_data:false
			})
		} 
	}

	onFacilityChange=(e)=>{
		this.validator.hideMessages();
		this.setState({
			show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
			del_frequency_id:0,
            work_count:0,
			freq_id:0,
			occur_count:0
		})
		var id=e.target.value;
		if(id>0)
		{
			this.setState({
				selected_facility:id,
				show_div:false,
				dustbinsBoxList:[],
				periodical:[],
				exist_update:false,
				configured_data:false
			})
		}
		else
		{
			this.setState({
				selected_facility:0,
				show_div:false,
				dustbinsBoxList:[],
				periodical:[],
				exist_update:false,
				configured_data:false
			})
		}
	}

	toggle() {
		this.validator.hideMessages();
	this.setState({
		modal: !this.state.modal
	});
}

resetClick(){

	var dustbinsBoxList=this.state.dustbinsBoxList;
	if(dustbinsBoxList.length>0){
		var exist_peridicals=this.state.exist_peridicals;
		this.setState({
			periodical:exist_peridicals,
			dustbinsBoxList:[]
		  });
	}
	
}

	onApplyClick(){
	  var that=this;

		if( that.validator.fieldValid('selected_group') && that.validator.fieldValid('selected_facility') )
		{
			that.setState({
				show_div:false,
				dustbinsBoxList:[],
				periodical:[],
				exist_update:false,
				configured_data:false,
				contract_data:[]
			})

			var group_id=this.state.selected_group;
			var facility_id=this.state.selected_facility;
			
			// Get the first contract for this group (or you can add contract selection later)
			var contract_id = this.props.contract_data && this.props.contract_data.length > 0 
				? this.props.contract_data[0].id 
				: 0;
			
			this.setState({
				selected_contract: contract_id
			});

			var post={contract_id:contract_id,facility_id:facility_id};
			this.props.dispatch(checkExistContractFacility(post));
			this.setState({
				load_from:false,
				blocking: true
			})
		}
		else
		{
			that.validator.showMessages();
			that.forceUpdate();
		}
	}

	saveClick(){

		this.validator.hideMessages();

		if(this.state.configured_data==false)
		{
			var periodcal_list=this.state.dustbinsBoxList;
			var facility_list=[];
			var contract_peridical_list=[];
			
			// Single facility selection
			var facility_id = this.state.selected_facility;
			var facility_name = "";
			if(this.props.facility_data && this.props.facility_data.length > 0) {
				var selected_fac = this.props.facility_data.find(f => f.id == facility_id);
				if(selected_fac) {
					facility_name = selected_fac.name;
				}
			}
			facility_list.push({contract_facility_id:facility_id,contract_facility_name:facility_name});
			
			if(periodcal_list.length>0 && facility_list.length>0)
			{
				periodcal_list.map(x=>{
					contract_peridical_list.push({contract_periodical_id:x.id,periodical_id:x.periodical_id,frequency_type_id:x.occurrence_id,frequency_count:x.frequency_count,estimated_hours_per_occurrence:0,is_seperately_charge:x.is_separately_charge,charge_type_id:x.charge_type_id,charge_amount:x.charge_amount,notes:x.notes,reporting_fields:x.reporting_fields});
				})

				var post=({facility_list:facility_list,contract_peridical_list:contract_peridical_list});
				console.log(post);
				this.props.dispatch(createContractFacilityPeriodicals(post));
				this.setState({
					show_div:false,
					dustbinsBoxList:[],
					periodical:[],
					exist_update:false,
					configured_data:false,
					contract_data:[],
					blocking: true
				})	
			}
			else
			{
				this.setState({
					show_error_no_element:true,
					blocking: true,
					visible:true
				})
			}
		}
		else
		{
			var update_list=this.state.dustbinsBoxList;
			var post=[];
			if(update_list.length>0){

				var contract_facility_id=this.state.selected_facility;
				var contract_facility_name="";
				if(this.props.facility_data && this.props.facility_data.length > 0) {
					var selected_fac = this.props.facility_data.find(f => f.id == contract_facility_id);
					if(selected_fac) {
						contract_facility_name = selected_fac.name;
					}
				}
				
				update_list.map(x=>{
					var id=0;
					var contract_periodical_id=0;
					
					if(x.tbl==undefined){
					   id=x.id;
					   contract_periodical_id=x.contract_periodical_id;
					}
					else
					{
						contract_periodical_id=x.id;
					}
				  post.push({id:id,contract_periodical_id:contract_periodical_id,contract_facility_id:contract_facility_id,contract_facility_name:contract_facility_name,periodical_id:x.periodical_id,frequency_type_id:x.occurrence_id,frequency_count:x.frequency_count,estimated_hours_per_occurrence:0,is_seperately_charge:x.is_separately_charge,charge_type_id:x.charge_type_id,charge_amount:x.charge_amount,notes:x.notes,reporting_fields:x.reporting_fields});

				})

				var post_data={periodical_array:post}
				console.log(post_data)

				this.props.dispatch(updateFacilityPeriodicalsData(post_data))
				this.setState({
					show_div:false,
					dustbinsBoxList:[],
					periodical:[],
					exist_update:false,
					configured_data:false,
					contract_data:[],
					del_frequency_id:0,
					work_count:0,
					freq_id:0,
					occur_count:0 ,
					blocking: true
				})
			}
			else
			{
				this.setState({
					show_error_no_element:true,
					visible:true
				})
			}
		}
	}

	render() {

		const { reporting_type_data,group_data,contract_data,contract_facility_data,frequency_data,is_exist_contract_facility,contract_peridicals_data,preferance_data,charge_data,allocation_response,contract_facilitys_data,is_working_count,facility_data} = this.props

		return (
			<div>
				<BlockUi tag="div" blocking={this.state.blocking}>
				<Container fluid={true}>

					<div className="alloc-card">

						{/* SubHeader renders the header band (title + Save button) and filter row (dropdowns + Apply) */}
						<SubHeader
							validator={this.validator}
							onApplyClick={this.onApplyClick}
							saveClick={this.saveClick}
							selected_group={this.state.selected_group}
							selected_facility={this.state.selected_facility}
							group_data={group_data}
							facilitydata={facility_data}
							onGroupChange={this.onGroupChange}
							onFacilityChange={this.onFacilityChange}
						/>

						{/* Alert messages */}
						{allocation_response!=null && allocation_response!="" && allocation_response.success==true ?<AlertSuccess color={"success"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={allocation_response.message}/> :''}
						{this.state.show_error!=false?<AlertSuccess color={"danger"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={"Something went wrong or facility selection is mismatch please try again with different selection."}/>:''}
						{this.state.show_error_no_element!=false?<AlertSuccess color={"danger"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={"Please drag and drop some periodicals in to frequency list for further process."}/>:''}
						{this.state.show_dlt_error!=false?<AlertSuccess color={"success"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={"Record has been successfully deleted."}/>:''}
						{this.state.show_nodelet!=false?<AlertSuccess color={"danger"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={"This allocation cannot be deleted. Some tasks have already been completed."}/>:''}
						{this.state.load_no_data!=false?<AlertSuccess color={"danger"} visible={this.state.visible} onDismiss={this.onDismiss} alertText={"There is no record found from selected facility. Please try again to load with different facility."}/>:''}

						{/* Two-panel Kanban body — shown after Apply */}
						{this.state.show_div==true && (
							<div className="alloc-card__body">
								<div className="alloc-panels">

									{/* Left panel: draggable Contract Periodicals */}
									<div className="alloc-panel--left">
										<div className="alloc-panel__label">Contract Periodicals</div>
										<div className="alloc-item-list">
											{this.state.periodical.map(({ id, name, is_separately_charge, icon }, index) => (
												<PeriodicalIteams
													id={id}
													name={name}
													type={name}
													icon={icon}
													isDropped={this.isDropped(name)}
													is_separately_charge={is_separately_charge}
													key={id}
													deleteClick={this.delete_toggle}
												/>
											))}
										</div>
									</div>

									{/* Right panel: Frequency Master drop zones */}
									<div className="alloc-panel--right">
										<div className="alloc-panel__label">
											Frequency Master
											{this.state.configured_data==false && (
												<button
													className="alloc-save-btn"
													style={{ float: 'right', fontSize: '12px', padding: '5px 12px' }}
													onClick={this.resetClick}
													type="button"
												>
													Reset
												</button>
											)}
										</div>
										<div className="alloc-freq-grid">
											{frequency_data.map(({ id, name, occur_frequency, icon }, index) => (
												<FrequencyList
													key={id}
													id={id}
													f_key={id}
													name={name}
													deleteClick={this.delete_toggle}
													onpClick={this.onpClick}
													occur_frequency={occur_frequency}
													onDrop={item => this.handleDrop(index, id, item, name, occur_frequency, icon)}
													content={this.state.dustbinsBoxList}
												/>
											))}
										</div>
									</div>

								</div>
							</div>
						)}

					</div>

					{/* Modals — unchanged */}
					<ContractPeridicalModal onMandatoryCheck={this.onMandatoryCheck} onrChange={this.onrChange} saveClick={this.saverClick} reporting_array={this.state.reporting_array} delete_report_click={this.delete_report_click} reporting_type={reporting_type_data} reporting_field={this.state.reporting_field} onSubmitClick={this.onSubmitClick} oncheck={this.oncheck} validator={this.validator} isOpen={this.state.modal} periodical_data={this.state.periodical_data} toggle={this.toggle} frequency_data={frequency_data} charge_data={charge_data} charged_show={this.state.charged_show} onChange={this.txtOnchange}/>
					<DeleteConfirmationModel isDeleteOpen={this.state.delete_model} delete_toggle={this.delete_toggle} delete_yes_toggle={this.confim_delete}/>

				</Container>
				</BlockUi>
			</div>
		)
	}



	
	handleDrop(index,id,item,f_name,occur_frequency) 
	{
		//console.log(item.id)
		this.validator.hideMessages();

		var that=this;
		this.setState({
			move_id:item.id,
			freq_id:id,
			occur_count:occur_frequency,
			show_error:false,
			show_error_no_element:false,
			show_dlt_error:false,
			show_nodelet:false,
			del_frequency_id:0
		})
		var  new_element="";
		var single_periodical = that.state.periodical.filter(function(x) { return x.id == item.id });
		//console.log(single_periodical[0].id);
		if(single_periodical!=null && single_periodical!="")
		{
			//console.log(single_periodical[0].icon)
			var amount=single_periodical[0].charge_amount;
				if(amount!="" && amount!=null){
					amount=amount.toString();
				}
			
		  new_element={id:single_periodical[0].id, name: single_periodical[0].name,description:single_periodical[0].description,periodical_id:single_periodical[0].periodical_id,occurrence_id:id,frequency_count:occur_frequency,allocation_preference_id:single_periodical[0].allocation_preference_id,is_separately_charge:single_periodical[0].is_separately_charge,charge_type_id:single_periodical[0].charge_type_id,charge_amount:amount,status:single_periodical[0].status,tbl:8,notes:'',icon:single_periodical[0].icon,reporting_fields:single_periodical[0].reporting_fields};
		}
		

		var periodicalLists = that.state.periodical.filter(function(x) { return x.id != item.id });
		that.setState({periodical:periodicalLists});
		
		var list_data = that.state.dustbinsBoxList.filter(function(y) { return y.id != item.id });

		var list_element = that.state.dustbinsBoxList.filter(function(y) { return y.id == item.id });
		if(list_element!=null && list_element!="")
		{
			
			if(this.state.configured_data==false || list_element[0].tbl>0)
			{
				console.log(list_element[0].icon)
				var amount=list_element[0].charge_amount;
				if(amount!="" && amount!=null){
					amount=amount.toString();
				}
				new_element={id:list_element[0].id, name: list_element[0].name,description:list_element[0].description,occurrence_id:id,periodical_id:list_element[0].periodical_id,frequency_count:occur_frequency,allocation_preference_id:list_element[0].allocation_preference_id,is_separately_charge:list_element[0].is_separately_charge,charge_type_id:list_element[0].charge_type_id,charge_amount:amount,status:list_element[0].status,tbl:list_element[0].tbl,notes:list_element[0].notes,icon:list_element[0].icon,reporting_fields:list_element[0].reporting_fields};
			}
			else
			{
				this.props.dispatch(isWorkingOnPeriodical(item.id));
			}

		}
		//  var list_data=list_data1;
		var parray=[];
	    console.log(new_element)
			if(new_element!="" && new_element!=null)
			{
				list_data.push(new_element);
				parray.push(new_element);
				that.setState({
					dustbinsBoxList : list_data,
					charged_show:new_element.is_separately_charge,
					periodical_data:parray,
					reporting_array:parray[0].reporting_fields,
					modal:true,
					work_count:0,
					move_id:0,
					freq_id:0,
			        occur_count:0
				});

				console.log(parray[0].reporting_fields)
			}
			else
			{

			}

		const { name } = item
		const droppedBoxNames = name ? { $push: [name] } : {}

	}
}

PeriodicalConfig.propTypes = {
  
}

function mapStateToProps(state) {
  const {postsBySubreddit,allocationReducer } = state
  const {
	group_items: group_data,
	contract_facility_data:contract_facility_data,
	contract_data:contract_data,
	frequency_data:frequency_data,
	charge_data:charge_data,
	preferance_data:preferance_data,
	facility_data:facility_data,
	reporting_type_data:reporting_type_data

  } =  postsBySubreddit 

  const{
	is_exist_contract_facility:is_exist_contract_facility,
	contract_peridicals_data:contract_peridicals_data,
	allocation_response:allocation_response,
	contract_facilitys_data:contract_facilitys_data,
	is_working_count:is_working_count
  }=allocationReducer

  return {
	group_data,
	contract_facility_data,
	contract_data,
	frequency_data,
	is_exist_contract_facility,
	contract_peridicals_data,
	preferance_data,
	charge_data,
	allocation_response,
	contract_facilitys_data,
	is_working_count,
	facility_data,
	reporting_type_data
  }
}


const AppContainer = connect(
	mapStateToProps
)(PeriodicalConfig);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/index.js